import CloseIcon from '@mui/icons-material/Close';
import { useMediaQuery } from '@mui/material';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';

import { CustomButton, Icon } from '../../components';
import { Sorting } from '../../components/Sorting';
import { useActions } from '../../hooks/useActions';
import { useFavorite } from '../../hooks/useFavorite';
import { useLayout } from '../../hooks/useLayout';
import '../../pages/Catalog/Catalog.sass';

import { FavoriteItems } from './FavoriteItems';
import './Favorites.sass';

//Иконка сортировки
const SortIcon = () => <Icon variant="sortIcon" />;

//Избранное
export const Favorites = () => {
  const { setDescription, setPage, setTitleTab } = useActions();
  const { favorites, favoriteQuantity } = useFavorite();
  const { page } = useLayout();
  //Сортировка
  const favoriteSort: any = [{ sort: 'new', text: 'Сначала новые' }];
  const mobileScreen = useMediaQuery('(max-width:900px)');
  useEffect(() => {
    //Заголовок вкладки страницы
    setTitleTab('Dazel.ru - Избранное');
    //Описание вкладки страницы
    setDescription('');
    //На какой мы странице
    setPage('favorite');
    //На странице избранное, переключить переключатель в "grid".
  }, [page]);
  return (
    <div className="favorites-page">
      <div className="favorites-page__wrapper">
        <div className="favorites-page__top">
          <div className="favorites-page__left">
            <h1 className="favorites-page__title">Избранное</h1>
            {favoriteQuantity !== 0 && !mobileScreen && (
              <Sorting select="new" sorts={favoriteSort} icon={SortIcon} />
            )}
          </div>
          {favoriteQuantity !== 0 && (
            <Link to="/">
              <div className="favorites-page__right">
                <div className="favorites-page__icon">
                  <CloseIcon />
                </div>
                <div className="favorites-page__shopping">
                  Вернуться к покупкам
                </div>
              </div>
            </Link>
          )}
        </div>
        {favoriteQuantity !== 0 ? (
          <FavoriteItems items={favorites} />
        ) : (
          <div className="Checkout_empty">
            <h2 className="Checkout_empty_title">В избранном пусто</h2>
            <p className="Checkout_empty_text">
              Добавляйте товары с помощью ❤️️
            </p>
            <Link to="/">
              <CustomButton variant="blue" className="empty_home">
                Перейти на главную
              </CustomButton>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default Favorites;
